import type * as Types from '../../types';

import client from "apollo/client";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCertifcateTypeNamesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCertifcateTypeNamesQuery = { __typename?: 'Query', certificateTypes?: { __typename?: 'CertificateTypeCollectionSegment', items?: Array<{ __typename?: 'CertificateType', key: string, value: string }> | null } | null };


        export type ExecGetCertifcateTypeNamesOptions = Omit<
        Apollo.QueryOptions<
        GetCertifcateTypeNamesQueryVariables, GetCertifcateTypeNamesQuery
        >,
        "query"
      >;
    export const execGetCertifcateTypeNamesQuery = (options: ExecGetCertifcateTypeNamesOptions) =>
    client.query< GetCertifcateTypeNamesQuery, GetCertifcateTypeNamesQueryVariables>({
      ...options,
      query: GetCertifcateTypeNamesDocument,
    });
    

export const GetCertifcateTypeNamesDocument = gql`
    query getCertifcateTypeNames {
  certificateTypes {
    items {
      key: id
      value: certificateTypeName
    }
  }
}
    `;

/**
 * __useGetCertifcateTypeNamesQuery__
 *
 * To run a query within a React component, call `useGetCertifcateTypeNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertifcateTypeNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertifcateTypeNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCertifcateTypeNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetCertifcateTypeNamesQuery, GetCertifcateTypeNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCertifcateTypeNamesQuery, GetCertifcateTypeNamesQueryVariables>(GetCertifcateTypeNamesDocument, options);
      }
export function useGetCertifcateTypeNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCertifcateTypeNamesQuery, GetCertifcateTypeNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCertifcateTypeNamesQuery, GetCertifcateTypeNamesQueryVariables>(GetCertifcateTypeNamesDocument, options);
        }
export type GetCertifcateTypeNamesQueryHookResult = ReturnType<typeof useGetCertifcateTypeNamesQuery>;
export type GetCertifcateTypeNamesLazyQueryHookResult = ReturnType<typeof useGetCertifcateTypeNamesLazyQuery>;
export type GetCertifcateTypeNamesQueryResult = Apollo.QueryResult<GetCertifcateTypeNamesQuery, GetCertifcateTypeNamesQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
          export type ResultType<T> = Types.ResultType<T>;
          export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
          export type NonMaybe<T> = Types.NonMaybe<T>;
          export type Maybe<T> = Types.Maybe<T>;